import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const map = {
  getWebapigwUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE
  },
  getClientId () {
    return store.getters['Client/clientId']
  },
  getMap (locationId) {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/map`, headers)
  },
  getMapWayfinding (locationId) {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/wayfinding/map`, headers)
  },
  getMapWayfindingAdmin (locationId) {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/wayfinding/map`, headers)
  },
  getWayfindingStartPoints(locationId){
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/wayfinding/starts`)
  },
  getMapAdmin (queryParams) {
    let headers = { responseType: 'arraybuffer' }
    if(queryParams.clientId) {
      return Axios.get(`api/${strings.apiVersion.admin}/clients/${queryParams.clientId}/locations/${queryParams.locationId}/map`, headers)
    }
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${queryParams}/map`, headers)
  },
  setMap (locationId, map) {
    var file = new FormData()
    file.append('mapFile', map)
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/map`, file)
  },
  setMapWayfinding (locationId, map) {
    var file = new FormData()
    file.append('mapFile', map)
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/wayfinding/map`, file)
  },
  getMapPosition (locationId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/workspaces`)
  },
  saveMapPosition(queryParams, bodyParams) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${queryParams.locationId}/workspaces`, bodyParams)
  },
  getMapUrl(locationId){
    return Axios.get(`${this.getWebapigwUrl()}/api/v1/clients/${this.getClientId()}/locations/${locationId}/maps`, {
      ignoreGlobalCatch: true,
    })
  },
}

export default map
